import Modal from 'react-modal';
import styled from 'styled-components';
import images from '../../../images';

const customModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '75%',
    paddingBottom: 10,
    borderRadius: 8,
    border: 'none'
  }
};

const NextButton = styled.button`
  margin-bottom: 5px;
  margin-top: 5px;
`;

const ResultItemContainer = styled.div`
  display: flex;
  position: relative;
  padding-left: 28px;
  margin-bottom: 10px;

  &.correct
  ,&.wrong {
    &:before {
      content: '';
      position: absolute;
      left: 0;
      width: 25px;
      height: 25px;
      background-size: contain;
      background-position: center;
    }
  }

  &.correct {
    &:before {
      background-image: url(${images.correct});
    }
  }
  &.wrong {
    &:before {
      background-image: url(${images.wrong});
    }
  }
`;

const LevelClearModal = ({
  clearedLevel,
  totalCorrectAnswers,
  totalWrongAnswers,
  isVisible,
  onClose,
  onContinue
}) => (
  <Modal
    isOpen={isVisible}
    onRequestClose={onClose}
    style={customModalStyles}
    overlayClassName="signup-modal-overlay"
  >
    <h2>
      Level
      {clearedLevel}
      {' '}
      Completed!
    </h2>
    <ResultItemContainer className="correct">
      Correct:
      {' '}
      {totalCorrectAnswers}
    </ResultItemContainer>
    <ResultItemContainer className="wrong">
      Wrong:
      {' '}
      {totalWrongAnswers}
    </ResultItemContainer>
    <NextButton onClick={onContinue}>
      Continue
    </NextButton>
  </Modal>
);

export default LevelClearModal;
